module.exports = __webpack_public_path__ + "img/base_activites_groupes.426eb581.svg";